import { useState, useEffect } from 'react';

const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : 'https://kiyafet-magazasi-backend.vercel.app';

const fallbackImage = 'https://images.unsplash.com/photo-1678723357379-d87f2a0ec8ec?w=400';

export function CategorySection() {
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    fetch(`${API_URL}/api/kategoriler`)
      .then(res => res.json())
      .then(data => { if (Array.isArray(data)) setCategories(data); })
      .catch(err => console.error('Kategoriler yüklenemedi:', err));
  }, []);

  if (categories.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 py-16">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900">Kategoriler</h2>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.filter(c => c.aktif !== false && c.ad !== 'Tümü').map((category, index) => (
          <a
            key={index}
            href={`/kategori/${String(category.ad || '')
              .toLowerCase()
              .replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
              .replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ç/g, 'c')
              .replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, '')}`}
            className="group relative overflow-hidden rounded-lg aspect-[3/4]"
          >
            <img 
              src={category.resim || fallbackImage}
              alt={category.ad}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-pink-600/80 via-pink-600/40 to-transparent flex items-end justify-center pb-4">
              <h3 className="text-white text-base md:text-lg font-semibold text-center px-2">{category.ad}</h3>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
